import { z } from 'zod';

export enum ProcessArtifactDirection {
    INPUT = 'INPUT',
    OUTPUT = 'OUTPUT',
}

export const ProcessArtifactDirectionSchema = z.enum(ProcessArtifactDirection);
